import gql from 'graphql-tag';

export const gqlGetNotifications = gql`
  query getNotifications($limit: Int, $offset: Int, $order: String, $where: String) {
    getNotifications(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        name
        typeCode
        responseType
        statusId
        tokenTtlDays
        composedDate
        closedDate
        notes
        isActive
        firstDate
        lastDate
        firstUser
        lastUser
      }
      recordCount
    }
  }
`;

export const gqlGetNotificationById = gql`
  query getNotificationById($id: Int) {
    getNotificationById(id: $id) {
      id
      name
      typeCode
      responseType
      statusId
      tokenTtlDays
      mailSubject
      mailHtml
      filterJson
      composedDate
      closedDate
      notes
      isActive
      firstDate
      lastDate
      firstUser
      lastUser
    }
  }
`;

export const gqlAddNotification = gql`
  mutation addNotification($data: NotificationInput) {
    addNotification(data: $data) {
      id
    }
  }
`;

export const gqlUpdateNotification = gql`
  mutation updateNotification($data: NotificationInput) {
    updateNotification(data: $data) {
      id
    }
  }
`;

export const gqlDeleteNotification = gql`
  mutation deleteNotification($id: Int) {
    deleteNotification(id: $id)
  }
`;

export const gqlGetNotificationRecipients = gql`
  query getNotificationRecipients($limit: Int, $offset: Int, $order: String, $where: String) {
    getNotificationRecipients(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        notificationId
        collectionpointId
        email
        mailsrepoId
        statusId
        sentDate
        failedDate
        failedReason
        respondedDate
        responseValue
        responsePayload
        sendCount
        isActive
        collectionpoint {
          id
          name
          addressLine1
          addressLine2
          addressArea
          addressCity
          addressNomos
          email
        }
      }
      recordCount
    }
  }
`;

export const gqlAddNotificationRecipient = gql`
  mutation addNotificationRecipient($data: NotificationRecipientInput) {
    addNotificationRecipient(data: $data) {
      id
    }
  }
`;

export const gqlUpdateNotificationRecipient = gql`
  mutation updateNotificationRecipient($data: NotificationRecipientInput) {
    updateNotificationRecipient(data: $data) {
      id
      email
      statusId
    }
  }
`;

/** Ζωντανό email καρτέλας σημείου — για ανανέωση στιγμιότυπου παραλήπτη σε προσχέδιο */
export const gqlGetCollectionpointEmailForNotification = gql`
  query getCollectionpointEmailForNotification($id: Int) {
    getCollectionpointById(id: $id) {
      id
      email
    }
  }
`;

export const gqlDeleteNotificationRecipient = gql`
  mutation deleteNotificationRecipient($id: Int) {
    deleteNotificationRecipient(id: $id)
  }
`;

export const gqlSendNotification = gql`
  mutation sendNotification($id: Int) {
    sendNotification(id: $id) {
      id
      statusId
      queuedCount
      skippedNoEmail
      skippedAlreadyQueued
    }
  }
`;

export const gqlCloseNotification = gql`
  mutation closeNotification($id: Int) {
    closeNotification(id: $id) {
      id
      statusId
      closedDate
    }
  }
`;

export const gqlResendNotification = gql`
  mutation resendNotification($id: Int, $recipientId: Int) {
    resendNotification(id: $id, recipientId: $recipientId) {
      id
      statusId
      queuedCount
      skippedNoEmail
    }
  }
`;

export const gqlGetNotificationResponseInfo = gql`
  query getNotificationResponseInfo($token: String) {
    getNotificationResponseInfo(token: $token) {
      notificationName
      collectionpointName
      typeCode
      responseType
      responseValue
      expired
      closed
      expiresAt
      collectionpoint {
        name
        addressLine1
        addressLine2
        postalCode
        addressArea
        addressCity
        addressNomos
        regionId
        subregionId
        contactPerson
        phone
        mobile
        email
        companyVat
        companyTaxOffice
      }
      regions {
        value
        label
        regionId
      }
      subregions {
        value
        label
        regionId
      }
      nomoi {
        value
        label
      }
    }
  }
`;

export const gqlRespondToNotification = gql`
  mutation respondToNotification(
    $token: String
    $answer: String
    $form: NotificationCollectionpointFormInput
  ) {
    respondToNotification(token: $token, answer: $answer, form: $form) {
      ok
      message
      responseValue
    }
  }
`;

export const gqlGetCollectionpointsForNotification = gql`
  query getCollectionpointsForNotification(
    $limit: Int
    $offset: Int
    $order: String
    $where: String
  ) {
    getCollectionpoints(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        name
        email
        addressLine1
        addressCity
        addressNomos
        isActive
      }
      recordCount
    }
  }
`;
